import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "@/utils/tailwind";

interface SwitchProps extends Omit<
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>,
  "onCheckedChange" | "checked" | "value" | "onChange"
> {
  value?: boolean;
  onChange?: (event: boolean) => void;
  readOnly?: boolean;
}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(({ className, value, onChange, readOnly = false, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-xs transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-brand-200 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand-500 data-[state=unchecked]:bg-grey-200",
      readOnly && "pointer-events-none",
      className,
    )}
    checked={value}
    onCheckedChange={onChange}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0",
      )}
    />
  </SwitchPrimitives.Root>
));
(Switch as React.FunctionComponent).displayName =
  SwitchPrimitives.Root.displayName;

export { Switch };
